import { useQuery } from '@tanstack/react-query';

/**
 * One page of a paged list whose first page arrived with the tab. While that
 * page is the one on screen it is read straight from the tab, so it refreshes
 * when the tab does and never fetches on its own. Any other page is fetched
 * the first time it is shown and kept for a minute.
 */
export function useServerPage<T>(queryKey: string, serverPage: T, isShowingServerPage: boolean) {
   const { data, isLoading, error, refetch } = useQuery<T>({
      queryKey: [queryKey],
      enabled: !isShowingServerPage,
      staleTime: 60_000,
   });
   if (isShowingServerPage) {
      return { data: serverPage, isLoading: false, error: null, refetch };
   }
   return { data, isLoading, error, refetch };
}
